import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFeeTypes } from "../ApiService/ApiService";

export const fetchFeeTypesAsync = createAsyncThunk(
  "feeTypes/fetchFeeTypes",
  async () => {
    const response = await getFeeTypes();
    return response.data;
  }
);

const initialState = {
  feeTypes: [],
  loading: false,
  error: null,
};

export const feeTypesSlice = createSlice({
  name: "feeTypes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeeTypesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeeTypesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.feeTypes = action.payload.data;
      })
      .addCase(fetchFeeTypesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllFeeTypes = (state) => state.feeTypes.feeTypes;
export const selectFeeTypesLoading = (state) => state.feeTypes.loading;
export const selectFeeTypesError = (state) => state.feeTypes.error;

export default feeTypesSlice.reducer;
